import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, HostListener } from '@angular/core';
import { SentEmail } from '../../../service/modal/sendEmai';
import { Globals } from '../../../globals';
import { SendEmailService } from '../../../service/apiservice/sendemail.service';
import { sendEmailmultiple, Approved } from 'src/app/service/modal/approved';
import { Router } from '@angular/router';
import { NgForm, AbstractControl, Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';




declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-sendemail',
  templateUrl: './sendemail.component.html',
  styleUrls: ['./sendemail.component.css']
})
export class SendemailComponent implements OnInit {
  sendEmailGrid: SentEmail[] = new Array();
  constructor(private fb: FormBuilder,private router: Router, private global: Globals, private chRef: ChangeDetectorRef, private sendemailService: SendEmailService) { }
  todayDate: any;
  sendEmailViewData: SentEmail = new SentEmail();
  newline: string = '/n';
  //attachment
  sendEmailAttachmentData: any;
  sendEmailAttachmentDataShow: any;
  declineDataId: any;

  //checkbox 
  showActions: boolean = false;
  selectedMailList = [];
  checkClickCount = 0;
  sendEmailObjActionShow = new SentEmail();

  //delete multiple
  selectedActionList: SentEmail[] = new Array();
  sendemail: SentEmail
  hoveredIndex;
  sendEmailmultiple = new sendEmailmultiple;
  emailId;
  @ViewChild('AttachmentCloseForm') attachment_CloseForm: ElementRef;
  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.GetSendEmail_Grid();
    this.todayDate = new Date();
    this.loadSendEmailForm();
  }
  GetSendEmail_Grid() {
    this.sendemailService.GetSendEmailList()
      .subscribe((response) => {
        if ($.fn.dataTable.isDataTable('#SendEmailDatatable')) {
          $('#SendEmailDatatable').dataTable().fnClearTable();
          $('#SendEmailDatatable').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#SendEmailDatatable_IsMobile')) {
          $('#SendEmailDatatable_IsMobile').dataTable().fnClearTable();
          $('#SendEmailDatatable_IsMobile').dataTable().fnDestroy();
        }

        // console.log(this.approvedGrid);
        Object.assign(this.sendEmailGrid, response);

        this.chRef.detectChanges();
        // $('#approvedDatatable').DataTable({
        //   dom: 'Bfrtip',
        //   buttons: [
        //     'copy', 'csv', 'excel', 'pdf', 'print'
        //   ]
        // });
        $("#SendEmailDatatable").DataTable({
          "paging": false,
          "info": false,
          "order": [[8, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Sent Pdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } },
            { extend: 'excel', title: 'Sent Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#SendEmailDatatable').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#SendEmailDatatable_filter").hide();

        $("#SendEmailDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Sent Pdf', attr: { id: "pdfBtnIsMobile" }, exportOptions: { columns: [2, 4] } },
            { extend: 'excel', title: 'Sent Excel', attr: { id: "excelBtnIsMobile" }, exportOptions: { columns: [2, 4] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#SendEmailDatatable_IsMobile').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#SendEmailDatatable_IsMobile_filter").hide();
      },
        error => {
          console.log(error);
        })
  }
  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }
  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    debugger;
    $("#pdfBtn").click();
  }

  ExportExcel_IsMobile() {
    $("#excelBtnIsMobile").click();
  }

  ExportPdf_IsMobile() {
    $("#pdfBtnIsMobile").click();
  }


  ViewDataBind(data: SentEmail) {
    Object.assign(this.sendEmailViewData, data);
  }
  AttachmentShow_DataBind(data) {
    this.sendEmailAttachmentDataShow = data;

  }
  Attachment_DataBind(data: any) {
    this.sendEmailAttachmentData = data;
  }
  Delete_PreBindData(id) {
    this.declineDataId = id;
  }
  DeleteSubmit() {
    this.sendemailService.DeleteSendEmail(this.declineDataId).subscribe(response => {
      this.GetSendEmail_Grid();
      info_noti('Deleted Success...');
      $("#DeclineConfirmModalForSendEmail").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }, err => {
    });
  }
  // checkboxChanged(event, obj) {
  //   debugger;
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);

  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList = Array.from(new Set(this.selectedMailList));

  //   if (this.selectedMailList.length > 0) {
  //     this.showActions = true;
  //     if (this.checkClickCount == 0) {
  //       this.checkClickCount = 1;
  //       this.sendEmailObjActionShow = obj;
  //     }
  //   }
  //   else {
  //     this.checkClickCount = 0;
  //     this.sendEmailObjActionShow = null;
  //     this.showActions = false;
  //   }
  // }

  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.sendEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.sendEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.sendEmailId);
          if (this.selectedMailList.length == this.sendEmailGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.sendEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          // this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        // this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.sendEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.sendEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.sendEmailId);
          if (this.selectedMailList.length == this.sendEmailGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.sendEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          // this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        // this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }




  //multiple delete
  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.sendemail = new SentEmail();
      this.sendemail.sendEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.sendemail;
    }
    this.sendemailService.DeleteMultipleSendEmail(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      $("#DeleteConfirmModalForSendEmail").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
      this.selectedMailList.length = 0;
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.sendEmailObjActionShow = null;
        this.checkClickCount = 0;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetSendEmail_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }

  Attachment_CloseClick() {
    this.attachment_CloseForm.nativeElement.click();
  }

  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }
  multipleForword(emailId,form:NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.sendemail = new SentEmail();
        this.sendemail.sendEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.sendemail;
      }
      this.sendEmailmultiple.sendEmail = this.selectedActionList;
      this.sendEmailmultiple.emailid = emailId;
      this.sendemailService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;
        // this.appvar
        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.sendEmailObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetSendEmail_Grid();
        this.emailId = "";
      
      }, error => {
        info_noti("Email Not send");
        // this.emailId
      
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }
  }

  sendEmailForm: FormGroup;
  loadSendEmailForm(){
      this.sendEmailForm = this.fb.group({
        'toAddress': ['', [Validators.required, this.commaSepEmail]]
      });
    }
  
    send(value) {
      console.log(value);
    }
  
    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value.split(',');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      console.log(forbidden);
      return forbidden ? { 'toAddress': { value: control.value } } : null;
    };
	
  sendMailClose() {
    this.emailId = "";
  }
  sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();
  }
  forwordEmailEnter(sendForwordemail,form:NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail,form);
  }
  downloadFile(path) {
    window.open(path, '_self');
  }
  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    $("#DeclineConfirmModalForSendEmail").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();


    $("#AttachmentModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#attchmentShowModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

  }


}
